import { hasPermission } from '../../services/parazol/core';

/**
 * @typedef {object} MenuEntry
 * @property {string} label
 * @property {string} href
 * @property {string} [icon]
 * @property {Array<MenuEntry>} [subNavItems]
 * @property {boolean} [isAllowed]
 */

/**
 * Creates menu entries from content types list payload.
 * @param {ContentType[]} contentTypesList
 * @returns {Array<MenuEntry>}
 */
const createMenuEntriesFromContentTypes = (contentTypesList) => contentTypesList
  .map((contentType) => (
    {
      label: contentType.schema.title,
      href: `/content/${contentType.id}/`,
    }));

/**
 * Creates menu entries.
 * @param {{contentTypes: Array<string>, media: Array<string>}} permissions
 * @param {Array<string>} userPermissions
 * @param {Function} translate
 * @param {ContentType[]} [contentTypesList]
 * @returns {{label:string, entries: Array<MenuEntry>}}
 */
export const createMenuEntries = (
  permissions,
  userPermissions,
  translate,
  contentTypesList,
) => ({
  label: '',
  entries: [].concat(
    contentTypesList
      ? {
        label: translate('cortizol.menu.contentsLabel'),
        href: '/content/',
        icon: '3dcube',
        subNavItems: createMenuEntriesFromContentTypes(contentTypesList),
        isAllowed: hasPermission(userPermissions, permissions.contentTypes || []),
      } : [],
    [{
      label: translate('cortizol.menu.mediaLabel'),
      href: '/media',
      icon: 'gallery',
      isAllowed: hasPermission(userPermissions, permissions.media || []),
    }],
  ),
});
